import React, { Component } from "react";
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';

// Tela de teste de notificações push (FCM). Acesso apenas via URL: /notificacoes/teste-push
class PushTest extends Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeData = this.handleChangeData.bind(this);
        this.adicionaParametro = this.adicionaParametro.bind(this);
        this.removeParametro = this.removeParametro.bind(this);
        this.enviar = this.enviar.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            token: '',
            titulo: '',
            corpo: '',
            parametros: [{ chave: '', valor: '' }],
            isSending: false,
            resultado: null
        }
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleChangeData(index, campo, valor) {
        const parametros = this.state.parametros.map((p, i) => i === index ? { ...p, [campo]: valor } : p);
        this.setState({ parametros });
    }

    adicionaParametro() {
        this.setState({ parametros: [...this.state.parametros, { chave: '', valor: '' }] });
    }

    removeParametro(index) {
        this.setState({ parametros: this.state.parametros.filter((p, i) => i !== index) });
    }

    montaData() {
        const data = {};
        this.state.parametros
            .filter(p => p.chave.trim() !== '')
            .forEach(p => { data[p.chave.trim()] = p.valor; });
        return data;
    }

    enviar(e) {
        e.preventDefault();
        const { token, titulo, corpo } = this.state;

        if (!token.trim() || !titulo.trim() || !corpo.trim()) {
            return this.setState({ resultado: { success: false, message: "Informe token, título e corpo." } });
        }

        this.setState({ isSending: true, resultado: null });

        axios.post(this.Configurations.apiBasePath + '/push-notification/teste', {
            token: token.trim(),
            titulo,
            corpo,
            data: this.montaData()
        }).then(response => {
            this.setState({ resultado: response.data });
        }).catch(err => {
            const resultado = err.response && err.response.data
                ? err.response.data
                : { success: false, message: err.message };
            this.setState({ resultado });
        }).finally(() => this.setState({ isSending: false }));
    }

    renderResultado() {
        const { resultado } = this.state;
        if (!resultado) return null;

        if (resultado.success) {
            return (
                <div className="alert alert-success mt-3">
                    <strong>Notificação enviada com sucesso.</strong>
                    <div className="small text-break">Message ID: {resultado.messageId}</div>
                </div>
            );
        }

        return (
            <div className="alert alert-danger mt-3">
                <strong>Erro ao enviar notificação.</strong>
                {resultado.code && <div className="small">Código: {resultado.code}</div>}
                <div className="small text-break">{resultado.message}</div>
            </div>
        );
    }

    render() {
        return (
            <div className="row push-test">
                <div className="col-12">
                    <div className="row no-gutters text-left">
                        <h2>Notificações - Teste de Push</h2>
                    </div>
                </div>
                <div className="col-12 col-lg-8">
                    <form className="card mt-3" onSubmit={this.enviar}>
                        <div className="card-body text-left">
                            <div className="form-group">
                                <label htmlFor="token">Token do dispositivo (FCM)</label>
                                <textarea id="token" name="token" className="form-control" rows="3"
                                    value={this.state.token} onChange={this.handleChange} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="titulo">Título</label>
                                <input id="titulo" name="titulo" type="text" className="form-control"
                                    value={this.state.titulo} onChange={this.handleChange} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="corpo">Corpo</label>
                                <textarea id="corpo" name="corpo" className="form-control" rows="3"
                                    value={this.state.corpo} onChange={this.handleChange} />
                            </div>

                            <label>Parâmetros (data)</label>
                            {this.state.parametros.map((p, index) => (
                                <div className="form-row mb-2" key={index}>
                                    <div className="col-5">
                                        <input type="text" className="form-control" placeholder="chave (ex: idConteudo)"
                                            value={p.chave} onChange={e => this.handleChangeData(index, 'chave', e.target.value)} />
                                    </div>
                                    <div className="col-5">
                                        <input type="text" className="form-control" placeholder="valor"
                                            value={p.valor} onChange={e => this.handleChangeData(index, 'valor', e.target.value)} />
                                    </div>
                                    <div className="col-2">
                                        <button type="button" className="btn btn-outline-danger btn-block"
                                            onClick={() => this.removeParametro(index)} title="Remover parâmetro">
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            ))}
                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={this.adicionaParametro}>
                                <i className="fas fa-plus"></i> adicionar parâmetro
                            </button>

                            <div className="text-right mt-3">
                                <button type="submit" className="btn btn-primary" disabled={this.state.isSending}>
                                    {this.state.isSending ? 'Enviando...' : 'Enviar notificação'}
                                </button>
                            </div>

                            {this.renderResultado()}
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default PushTest;
